import { st, sym } from "rdflib";
import { vcard } from "../namespaces.js";
import { generateId } from "@solid-data-modules/rdflib-utils/identifier";
export function addNewPhoneNumber(contactNode, phoneNumber) {
    const id = generateId();
    const uri = `${contactNode.doc().uri}#${id}`;
    return {
        uri,
        insertions: [
            st(contactNode, vcard("hasTelephone"), sym(uri), contactNode.doc()),
            st(sym(uri), vcard("value"), sym("tel:" + phoneNumber), contactNode.doc()),
        ],
        deletions: [],
        filesToCreate: [],
    };
}
//# sourceMappingURL=addNewPhoneNumber.js.map